// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/TicketDetailModal/index.css
// module id = 2249
// module chunks = 0